<template>
  <list listTitle="Migração de produtos" :listLogo="moduleDefinition.logo" filterTitle="Filtros" :loading="loading" :sortFields="sortFields" :sortDefault="{ field: sortFields[0], order: 'asc' }" :total="productsMigrationTotal" @change="onChange">
    <template slot="filters">
      <div class="l-col-12@md">
        <div class="l-row">
          <form-group label="Código do produto">
            <input class="form-input" v-model="options.sku">
          </form-group>

          <form-group label="Título do produto">
            <input class="form-input" v-model="options.title">
          </form-group>

          <form-group label="Status de Migração">
            <select v-model="options.status" class="form-select">
              <option :value=null>{{ $t('choose.label') }}</option>
              <option v-for="status in migration.status" :value="status">{{ $t(`mercadoLivre.migration.${status}.label`) }}</option>
            </select>
          </form-group>

          <form-group label="Status do Produto no Marketplace">
            <select v-model="options.active" class="form-select">
              <option :value=null>{{ $t('choose.label') }}</option>
              <option v-for="status in productMarketplaceActive.status" :value="status">{{ $t(`migration.statusProductMarketplace.${status}.label`) }}</option>
            </select>
          </form-group>
        </div>
      </div>
    </template>

    <div class="l-col-12@md" v-if="productsMigration.length">
      <product-migration-card v-for="productMigration in productsMigration" :key="productMigration" :module="module" :modules="modules" :product="productMigration"/>
    </div>
    <div class="l-col-12@md u-textCenter" v-else>
      <panel>Nenhum produto encontrado.</panel>
    </div>
  </list>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import { merge } from 'lodash'
  import List from '@/components/shared/list/Paginator'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import ProductMigrationCard from '@/components/ProductMigration/Card'

  export default {
    inject: ['expeditersDI'],
    data: () => ({
      module: {
        type: 'marketplace',
        identifier: 'cnova'
      },
      sortFields: [
        'title'
      ],
      migration: {
        status: [
          'pending',
          'done'
        ]
      },
      productMarketplaceActive: {
        status: [
          'true',
          'false'
        ]
      },
      statusesAnnouncement: [],
      loading: true,
      options: {
        account: null,
        status: null,
        title: null,
        sku: null,
        active: null
      },
      modules: []
    }),
    async created () {
      await this.clearProductsMigration()
    },
    mounted () {
      for (let i in this.expeditersDI) {
        const type = this.expeditersDI[i].type

        for (let j in this.expeditersDI[i].identifiers) {
          const identifier = this.expeditersDI[i].identifiers[j]

          if (!this.definitionModulesInstalled.find(module => module.type === type && module.identifier === identifier)) {
            continue
          }

          this.modules.push({
            type: type,
            identifier: identifier
          })
        }
      }
    },
    methods: {
      ...mapActions('mercadoLivreAccounts', [
        'fetchAccounts'
      ]),
      ...mapActions('productMigration', [
        'fetchProductsMigration',
        'fetchMoreProductsMigration',
        'clearProductsMigration'
      ]),
      onChange (options) {
        this.clearProductsMigration()

        this.loading = true

        if (options === undefined) {
          options = this.$children[0].options
        }

        merge(this.options, options)

        this.fetchProductsMigration({
          type: this.module.type,
          identifier: this.module.identifier,
          options: this.options,
          account: this.options.account
        })
          .finally(() => {
            this.loading = false
          })
      }
    },
    computed: {
      ...mapFields({
        productsMigration: 'productMigration.productsMigration',
        productsMigrationTotal: 'productMigration.total'
      }),
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType',
        'definitionModulesInstalled'
      ]),
      moduleDefinition () {
        return this.getDefinitionModuleByIdentifierAndType('marketplace', 'cnova')
      },
      products () {
        if (this.productsMigration) {
          return this.productsMigration
        }

        return []
      }
    },
    components: {
      List,
      Panel,
      FormGroup,
      ProductMigrationCard
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Cnova.vue?09e1f081